export const salesByLocation = [
  {
    locationName: "Fenway QA (Don't use)",
    salesByDateList: [
      {
        salesDate: '2023-01-01T00:00:00.000+00:00',
        totalSales: 262.678,
        totalOrders: 214.0,
      },
      {
        salesDate: '2023-01-02T00:00:00.000+00:00',
        totalSales: 183.545,
        totalOrders: 250.0,
      },
      {
        salesDate: '2023-01-03T00:00:00.000+00:00',
        totalSales: 257.029,
        totalOrders: 321.0,
      },
      {
        salesDate: '2023-01-04T00:00:00.000+00:00',
        totalSales: 0,
        totalOrders: 0,
      },
      {
        salesDate: '2023-01-05T00:00:00.000+00:00',
        totalSales: 43.321,
        totalOrders: 30.0,
      },
      {
        salesDate: '2023-01-06T00:00:00.000+00:00',
        totalSales: 0,
        totalOrders: 0,
      },
      {
        salesDate: '2023-01-07T00:00:00.000+00:00',
        totalSales: 189.312,
        totalOrders: 221.0,
      },
      {
        salesDate: '2023-01-08T00:00:00.000+00:00',
        totalSales: 492.246,
        totalOrders: 528.0,
      },
    ],
  },
  {
    locationName: 'Test Store 1',
    salesByDateList: [
      {
        salesDate: '2023-01-01T00:00:00.000+00:00',
        totalSales: 0,
        totalOrders: 0,
      },
      {
        salesDate: '2023-01-02T00:00:00.000+00:00',
        totalSales: 0,
        totalOrders: 0,
      },
      {
        salesDate: '2023-01-03T00:00:00.000+00:00',
        totalSales: 0,
        totalOrders: 0,
      },
      {
        salesDate: '2023-01-04T00:00:00.000+00:00',
        totalSales: 0,
        totalOrders: 0,
      },
    ],
  },
];
